<!-- Главная -->
<template>
  <li
    class="nav-item"
    role="button"
    tabindex="0"
    @click="navigate($event, 'Home')"
    @mouseup="handleMiddleClick($event, 'Home')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Home')"
    :class="{ active: activeItem === 'home' }"
    :title="collapsed ? 'Главная' : ''"
  >
    <div class="link-icon_box">
      <svg
        fill="#ffffff"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        class="icon"
      >
        <g>
          <path
            d="M21.71,11.29l-9-9a1,1,0,0,0-1.42,0l-9,9a1,1,0,0,0-.21,1.09A1,1,0,0,0,3,13H4v7.3A1.77,1.77,0,0,0,5.83,22H8.5a1,1,0,0,0,1-1V16.1a1,1,0,0,1,1-1h3a1,1,0,0,1,1,1V21a1,1,0,0,0,1,1h2.67A1.77,1.77,0,0,0,20,20.3V13h1a1,1,0,0,0,.92-.62A1,1,0,0,0,21.71,11.29Z"
          />
        </g>
      </svg>
    </div>
    <AppSidebarItemLabel
      label="Главная"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import {
  useSidebarItem,
  sidebarItemProps,
} from "@/composables/useSidebarItem";

export default {
  name: "HomeItem",
  components: { AppSidebarItemLabel },
  props: sidebarItemProps,
  emits: ["navigate", "middle-click", "context-menu"],
  setup(props, { emit }) {
    return useSidebarItem(emit);
  },
};
</script>
